"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
// SelectInputStyles.ts
const css_in_js_1 = require("../../components/css-in-js");
exports.styles = {
    host: (0, css_in_js_1.css) `
        display: block;
        font: inherit;
        width: 100%;
        position: relative;
    `,
    wrap: (0, css_in_js_1.css) `
        position: relative;
        width: 100%;
    `,
    selectInput: (0, css_in_js_1.css) `
        background: #fff;
        border: 1px solid #e5e5ea;
        border-radius: 8px;
        padding: 2px 12px 4px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        position: relative;
        cursor: pointer;
        user-select: none;
        outline: none;
    `,
    focusVisible: (0, css_in_js_1.css) `
        outline: 2px solid #7c3aed33;
        outline-offset: 2px;
    `,
    disabledTrigger: (0, css_in_js_1.css) `
        opacity: 0.6;
        cursor: not-allowed;
    `,
    texts: (0, css_in_js_1.css) `
        display: grid;
        gap: 0px;
        min-width: 0;
        flex: 1 1 auto;
    `,
    label: (0, css_in_js_1.css) `
        font-weight: 600;
        font-size: 12px;
        color: #6c6c79;
        line-height: 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    `,
    value: (0, css_in_js_1.css) `
        font-size: 14px;
        line-height: 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 300;
        color: #3f3e51;
    `,
    placeholder: (0, css_in_js_1.css) `
        color: #3f3e51;
    `,
    icons: (0, css_in_js_1.css) `
        display: inline-flex;
        align-items: center;
        flex: 0 0 auto;
    `,
    menu: (0, css_in_js_1.css) `
        position: absolute;
        left: 0;
        right: 0;
        top: calc(100% + 2px);
        background: #fff;
        border: 1px solid #e5e5ea;
        border-radius: 8px;
        overflow: hidden;
        z-index: 1000;
    `,
    searchRow: (0, css_in_js_1.css) `
        padding: 6px;
        border-bottom: 1px solid #e5e5ea;
    `,
    search: (0, css_in_js_1.css) `
        width: 100%;
        box-sizing: border-box;
        font: inherit;
        font-size: 14px;
        padding: 8px 10px;
        border: 1px solid #3b82f6;
        border-radius: 2px;
        outline: none;

        /* FIX: prevent inherited RTL/bidi styles from reversing typed text */
        direction: ltr;
        unicode-bidi: plaintext;
        text-align: left;
    `,
    searchFocus: (0, css_in_js_1.css) `
        box-shadow: none;
    `,
    list: (0, css_in_js_1.css) `
        max-height: 260px;
        overflow: auto;
    `,
    groupHeading: (0, css_in_js_1.css) `
        padding: 8px 10px;
        font-size: 13px;
        font-weight: 700;
        color: #3f3e51;
        background: #e8e8e8;
    `,
    option: (0, css_in_js_1.css) `
        padding: 10px 10px;
        font-size: 14px;
        line-height: 18px;
        color: #3f3e51;
        cursor: pointer;
    `,
    optionSelected: (0, css_in_js_1.css) `
        background: #3b82f6; /* blue selected row */
        color: #fff;
    `,
    optionActive: (0, css_in_js_1.css) `
        background: #eaf2ff;
    `,
    optionDisabled: (0, css_in_js_1.css) `
        opacity: 0.5;
        cursor: not-allowed;
    `,
    empty: (0, css_in_js_1.css) `
        padding: 10px 10px;
        color: #6c6c79;
        font-size: 14px;
    `,
};
//# sourceMappingURL=SelectInputStyles.js.map